
CheckoutV2.PayPalCheckout = function(checkout) {
	var _ppco = this;

	_ppco.$checkoutButton = $('.js-paypal-checkout');

	_ppco.init = function() {
		_ppco.listen();
	}

	_ppco.listen = function() {
		_ppco.$checkoutButton.click(_ppco.submit);
	}

	_ppco.submit = function(e) {
		
		// Check for estimate shipping zip, pop modal if we don't have it
		/*if (!checkout.cart.shipping.zip) {
			checkout.cart.shipping.$estimateShippingModal.modal('show');
			return;
		}*/
		
		checkout.loading('Sending you to PayPal...');
		
		var session = checkout.session.get();
		
		session.cartItems = checkout.cart.getItemData();
		session.totals = checkout.cart.totals.values;
		session.totals.taxRate = checkout.cart.totals.taxRate;
		// ensure paypal express checkout returns to review step
		session.initPaypalPayment = 1;
		session.reviewPayment = 1;
		if ($(e.target).data('funding'))
			session.funding = $(e.target).data('funding');
		else
			session.funding = false;


		
		if (checkout.shippingServiceGroupID) { 
			session.shippingServiceGroupID = checkout.shippingServiceGroupID; 
		} else { 
			delete session.shippingServiceGroupID; 
		}
		 
		session.shippingServiceCode = checkout.shippingServiceCode;
				
		var submission = new CheckoutV2.Submit(checkout, {
			'onFails' : [function() {
				checkout.loading();
			}]
		});

		return submission.submit({
			'step'   : 'paypal',
			'action' : 'initCheckout',
			'data'   : encodeURIComponent(JSON.stringify(session)),
			'options': encodeURIComponent(JSON.stringify( { 'newSite': checkout.config.isEndeca, 'isV2Checkout': checkout.config.isV2Checkout } ))
		});
	}

	_ppco.init()
}

